export default "__VITE_ASSET__2BvnyhjV__"